import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './PermissionTable.css';
import Tooltip from '@mui/material/Tooltip';
const PermissionTable = ({ items, hasEnableDisable = false, permissions, togglePermission }) => {
  
  // Handle "All" checkbox logic
  const handleAllCheckbox = (itemId) => {
    const actions = ['view', 'edit', 'create', 'delete'];
    const allSelected = actions.every(action => permissions[`${itemId}-${action}`]);
    
    // If all are selected, unselect all; otherwise select all
    actions.forEach(action => {
      const permissionKey = `${itemId}-${action}`;
      if (allSelected) {
        // Unselect all
        if (permissions[permissionKey]) {
          togglePermission(permissionKey);
        }
      } else {
        // Select all
        if (!permissions[permissionKey]) {
          togglePermission(permissionKey);
        }
      }
    });
    
    // Toggle the "all" permission itself
    togglePermission(`${itemId}-all`);
  };

  // Check if all permissions are selected for an item
  const isAllSelected = (itemId) => {
    const actions = ['view', 'edit', 'create', 'delete'];
    return actions.every(action => permissions[`${itemId}-${action}`]);
  };

  // Get selected permissions for display/debugging
  const getSelectedPermissionsString = (itemId) => {
    const actions = ['view', 'edit', 'create', 'delete'];
    const selected = actions.filter(action => permissions[`${itemId}-${action}`]);
    return selected.length > 0 ? selected.join(', ') : 'none';
  };

  return (
    <div>
      <table className="permission-table">
        <thead>
          <tr className="permission-header">
            <th className="permission-header-cell">Type</th>
            <th className="permission-header-cell">All</th>
            <th className="permission-header-cell">View</th>
            <th className="permission-header-cell">Edit</th>
            <th className="permission-header-cell">Create</th>
            <th className="permission-header-cell">Delete</th>
            {hasEnableDisable && <th className="permission-header-cell">Enable / Disable</th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
  <tr key={item.id} className="permission-row">
    <td className="permission-cell permission-type-cell">
      {item.label}
      
     {['QConnectAIAgents', 'QConnectAIPrompts', 'QConnectGuardrails'].includes(item.id) && (
        <Tooltip title="Configure access to Amazon Q features" arrow>
          <InfoOutlinedIcon
            style={{ fontSize: 16, marginLeft: 4, verticalAlign: 'middle', cursor: 'pointer' }}
          />
        </Tooltip>
      )}
      {/* <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>
        Selected: {getSelectedPermissionsString(item.id)}
      </div> */}
    </td>
              
              {/* All checkbox with special handling */}
              <td className="permission-cell">
                <input
                  type="checkbox"
                  className="permission-checkbox"
                  checked={isAllSelected(item.id)}
                  onChange={() => handleAllCheckbox(item.id)}
                />
              </td>
              
              {/* Individual permission checkboxes */}
              {['view', 'edit', 'create', 'delete'].map((action) => (
                <td key={action} className="permission-cell">
                  <input
                    type="checkbox"
                    className="permission-checkbox"
                    checked={permissions[`${item.id}-${action}`] || false}
                    onChange={() => togglePermission(`${item.id}-${action}`)}
                  />
                </td>
              ))}
              
              {/* Enable/Disable checkbox if applicable */}
              {hasEnableDisable && (
                <td className="permission-cell">
                  <input
                    type="checkbox"
                    className="permission-checkbox"
                    checked={permissions[`${item.id}-enable`] || false}
                    onChange={() => togglePermission(`${item.id}-enable`)}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionTable;